import api from './api';

export interface Turno {
  _id: string;
  nombre: string;
  horaEntrada: string;
  horaSalida: string;
  inicioValidezEntrada?: string;
  finValidezEntrada?: string;
  inicioValidezSalida?: string;
  finValidezSalida?: string;
  toleranciaLlegadaTarde: number;
  toleranciaSalidaTemprano: number;
  minutosTrabajo: number;
  rotativo: boolean;
  laborales?: number;
  noLaborales?: number;
  activo: boolean;
  empresaId?: string;
}

export interface CicloBloque {
  diaSemana: number;
  turnoId: string | Turno;
}

export interface Ciclo {
  _id: string;
  nombre: string;
  bloques: CicloBloque[];
  activo: boolean;
  empresaId?: string;
}

export interface AgenteHorario {
  _id: string;
  nombre: string;
  documento?: string;
  idAgente?: string;
  telefono?: string;
}

export interface AsignacionCiclo {
  _id: string;
  agenteId: AgenteHorario | string;
  cicloId: Ciclo | string;
  activo: boolean;
  createdAt?: string;
}

export interface CreateTurnoPayload {
  nombre: string;
  horaEntrada: string;
  horaSalida: string;
  inicioValidezEntrada?: string;
  finValidezEntrada?: string;
  inicioValidezSalida?: string;
  finValidezSalida?: string;
  toleranciaLlegadaTarde?: number;
  toleranciaSalidaTemprano?: number;
  rotativo?: boolean;
  laborales?: number;
  noLaborales?: number;
  activo?: boolean;
}

export interface CreateCicloPayload {
  nombre: string;
  bloques: Array<{ diaSemana: number; turnoId: string }>;
  activo?: boolean;
}

export type AttendanceEstado = 'TODOS' | 'OK' | 'OBSERVADO' | 'AUSENTE' | 'JUSTIFICADO' | 'FERIADO';

export interface AttendanceCalcRow {
  userid: string;
  name: string;
  idcard: string;
  fecha: string;
  horaEntradaTurno: string;
  horaSalidaTurno: string;
  horaEntradaReal: string;
  horaSalidaReal: string;
  ausente: 'SI' | 'NO';
  llegadaTarde: 'SI' | 'NO';
  justificacion: string;
  tipoJustificacion: string;
  feriado: 'SI' | 'NO';
  tipoFeriado: string;
  diaSemana: string;
  turnoNocturno: 'SI' | 'NO';
  salidaTemprano: 'SI' | 'NO';
  minutosTrabajados: number;
  horasTrabajadas: number;
  estado: AttendanceEstado;
  ciclo: string;
  turno: string;
  laborales?: number;
  noLaborales?: number;
  patronRotativo?: string;
  tipoDia?: 'LABORAL' | 'DESCANSO';
}

export interface AttendanceCalcResponse {
  meta: {
    periodoDesde: string;
    periodoHasta: string;
    totalFilas: number;
  };
  rows: AttendanceCalcRow[];
}

export interface AttendanceFilterPayload {
  desde: string;
  hasta: string;
  agenteId?: string;
  cicloId?: string;
  estado?: AttendanceEstado;
}

export const getTurnos = () => api.get<Turno[]>('/horarios/turnos');
export const createTurno = (data: CreateTurnoPayload) => api.post<Turno>('/horarios/turnos', data);
export const updateTurno = (id: string, data: Partial<CreateTurnoPayload>) =>
  api.patch<Turno>(`/horarios/turnos/${id}`, data);

export const getCiclos = () => api.get<Ciclo[]>('/horarios/ciclos');
export const createCiclo = (data: CreateCicloPayload) => api.post<Ciclo>('/horarios/ciclos', data);
export const updateCiclo = (id: string, data: Partial<CreateCicloPayload> & { activo?: boolean }) =>
  api.patch<Ciclo>(`/horarios/ciclos/${id}`, data);

export const getAgentesHorarios = () => api.get<AgenteHorario[]>('/horarios/agentes');
export const getAsignaciones = () => api.get<AsignacionCiclo[]>('/horarios/asignaciones');

export const asignarCiclo = (cicloId: string, agenteIds: string[]) =>
  api.post<{ creadas: number; reactivadas: number; omitidas: number }>('/horarios/asignaciones', {
    cicloId,
    agenteIds,
  });

export const desasociarAsignacion = (id: string) => api.patch(`/horarios/asignaciones/${id}/desasociar`, {});
export const eliminarAsignacion = (id: string) => api.delete(`/horarios/asignaciones/${id}`);

export const getAsistenciaCiclosAgentes = () => api.get<AgenteHorario[]>('/reports/asistencia-ciclos/agentes');
export const getAsistenciaCiclosCatalog = () => api.get<Array<{ _id: string; nombre: string }>>('/reports/asistencia-ciclos/ciclos');
export const getAsistenciaCiclos = (params: AttendanceFilterPayload) =>
  api.get<AttendanceCalcResponse>('/reports/asistencia-ciclos', { params });

export const exportAsistenciaCiclosCsv = (params: AttendanceFilterPayload) =>
  api.get('/reports/asistencia-ciclos/csv', {
    params,
    responseType: 'blob',
  });
